(() => {
  const configNode = document.querySelector('[data-lb-config]');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-IE', {style: 'currency', currency: 'EUR'}).format(cents / 100);
  let timer;
  let requestVersion = 0;

  function controls() {
    document.querySelectorAll('[data-cart-item]').forEach(row => {
      const title = row.querySelector('.cart__item--title a, .mini-cart__item-title a')?.textContent.trim() || '';
      row.querySelectorAll('.js-change-quantity').forEach(button => {
        button.setAttribute('role', 'button');
        button.setAttribute('tabindex', '0');
        button.setAttribute('aria-label', button.dataset.func === 'minus' ? config.decrease : config.increase);
      });
      const input = row.querySelector('[data-cart-quantity-input]');
      if (input) input.setAttribute('aria-label', `${config.quantity}: ${title}`);
      const remove = row.querySelector('[data-remove-item]');
      if (remove) {
        remove.setAttribute('aria-label', `${config.remove}: ${title}`);
        if (remove.dataset.removeItem === 'mini-cart') remove.textContent = config.remove;
      }
    });
  }

  function render(cart) {
    document.querySelectorAll('[data-lb-delivery]').forEach(box => {
      box.hidden = !cart.item_count || !cart.requires_shipping;
      const ireland = box.dataset.lbCountry === 'IE' && cart.currency === 'EUR';
      const remaining = Number(box.dataset.lbThreshold) - cart.total_price;
      box.querySelector('[data-lb-rate]').textContent = ireland ? (remaining <= 0 ? box.dataset.lbFree : box.dataset.lbPaid) : box.dataset.lbOther;
      const note = box.querySelector('[data-lb-remaining-text]');
      note.hidden = !ireland || remaining <= 0;
      note.textContent = ireland && remaining > 0 ? box.dataset.lbRemaining.replace('__AMOUNT__', money(remaining)) : '';
    });
    document.querySelectorAll('.mini-cart__item').forEach(row => {
      const item = cart.items[Number(row.dataset.lineId) - 1];
      if (!item || String(item.variant_id) !== row.dataset.variantId) return;
      const title = row.querySelector('.mini-cart__item-title a');
      if (title) title.textContent = item.product_title;
      row.querySelector('.lb-item-options')?.remove();
      if (item.has_only_default_variant) return;
      const list = document.createElement('ul');
      list.className = 'lb-item-options';
      (item.options_with_values || []).forEach(option => {
        if (option.value === 'Default Title') return;
        const line = document.createElement('li');
        line.textContent = `${option.name}: ${option.value}`;
        list.append(line);
      });
      title?.parentElement.after(list);
    });
    controls();
  }

  function schedule() {
    controls();
    clearTimeout(timer);
    const version = ++requestVersion;
    timer = setTimeout(async () => {
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {credentials: 'same-origin', cache: 'no-store'});
        if (!response.ok) throw new Error('Cart unavailable');
        const cart = await response.json();
        if (version === requestVersion) render(cart);
      } catch {
        if (version !== requestVersion) return;
        document.querySelectorAll('[data-lb-delivery]').forEach(box => {
          box.querySelector('[data-lb-rate]').textContent = box.dataset.lbOther;
          box.querySelector('[data-lb-remaining-text]').hidden = true;
        });
      }
    }, 120);
  }

  document.addEventListener('keydown', event => {
    const button = event.target.closest('[data-cart-item] .js-change-quantity[role=button]');
    if (button && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      if (!button.classList.contains('is-disabled')) button.click();
    }
  });
  const observer = new MutationObserver(schedule);
  document.querySelectorAll('.js-cart_items, .js-cart_subtotal').forEach(node => observer.observe(node, {childList: true}));
  schedule();
})();
